import { render, staticRenderFns } from "./Prestacion.vue?vue&type=template&id=16054197&scoped=true"
import script from "./Prestacion.vue?vue&type=script&lang=js"
export * from "./Prestacion.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Prestacion.vue?vue&type=style&index=2&id=16054197&prod&lang=css"
import style3 from "./Prestacion.vue?vue&type=style&index=3&id=16054197&prod&scoped=true&lang=css"
import style4 from "./Prestacion.vue?vue&type=style&index=4&id=16054197&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16054197",
  null
  
)

export default component.exports